import { Outlet, NavLink } from "react-router-dom";
import { Home, Users, Calendar, Settings } from "lucide-react";

const tabs = [
  { to: "/admin", icon: Home, label: "Accueil", testId: "nav-admin-today", end: true },
  { to: "/admin/clients", icon: Users, label: "Clients", testId: "nav-admin-clients" },
  { to: "/admin/calendrier", icon: Calendar, label: "Calendrier", testId: "nav-admin-calendar" },
  { to: "/admin/reglages", icon: Settings, label: "Réglages", testId: "nav-admin-settings" },
];

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] bg-grain">
      <div className="max-w-2xl mx-auto pb-24">
        <Outlet />
      </div>

      <nav className="fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-t border-[#E5DEC9]">
        <div className="max-w-2xl mx-auto grid grid-cols-4">
          {tabs.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testId}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center gap-1 py-2.5 text-xs font-medium transition-colors ${
                  isActive ? "text-[#581825]" : "text-[#6E675F]"
                }`
              }>
              {({ isActive }) => (
                <>
                  {isActive && <span className="absolute top-0 h-0.5 w-10 rounded-full bg-[#C5A059]" />}
                  <t.icon className="w-5 h-5" strokeWidth={isActive ? 2.4 : 1.8} />
                  {t.label}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
